import { render, staticRenderFns } from "./compWaitingRecordLog.vue?vue&type=template&id=1b2fcae6&"
import script from "./compWaitingRecordLog.vue?vue&type=script&lang=js&"
export * from "./compWaitingRecordLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports